// @flow
import SidebarEntityItem from './SidebarEntityItem';

export default SidebarEntityItem;
